<p>list-values-product-configuration works!</p>
